import { Box, Text, Tooltip } from "@chakra-ui/react";
import { getAssetLongName } from "@syla/shared/helpers/assets/getAssetLongName";
import { getAssetName } from "@syla/shared/helpers/assets/getAssetName";
import { getAssetShortName } from "@syla/shared/helpers/assets/getAssetShortName";
import React from "react";
import { BalanceDetail } from "../../../../../helper/ledger/aggregateBalanceInLedgers";
import { NumberStyler } from "../../../../../helper/NumberStyler";
import { useTransactionsStore } from "../../../../../store/transactionsStore";
import { ImageWithMissingSrc } from "../../../../atoms/ImageWithMissingSrc";
import { SkeletonRect } from "../../../../atoms/Skeletons";
import { TableCell, TableRow, TableHeaderCell, TableHeaderRow } from "./Table";

export function BalanceTableRow({
  balanceDetail,
}: {
  balanceDetail: BalanceDetail;
}): React.ReactElement {
  const isInvalid = useTransactionsStore((state) => state.refreshing);

  return (
    <TableRow>
      <TableCell>
        <ImageWithMissingSrc
          src={balanceDetail.asset.image}
          alt=""
          w="2rem"
          h="2rem"
          mr="1rem"
        />
        <Tooltip label={getAssetLongName(balanceDetail.asset)}>
          <Box>
            <Text noOfLines={1}>{getAssetShortName(balanceDetail.asset)}</Text>
            <Text noOfLines={1} fontSize="sm" fontWeight="light">
              {getAssetName(balanceDetail.asset)}
            </Text>
          </Box>
        </Tooltip>
      </TableCell>

      <TableCell justifyContent="left">
        <SkeletonRect w="full" isLoaded={!isInvalid}>
          <NumberStyler
            fontSize="md"
            num={balanceDetail.walletBalance}
            assetInfo={balanceDetail.asset}
          />
        </SkeletonRect>
      </TableCell>

      <TableCell justifyContent="left">
        <SkeletonRect w="full" isLoaded={!isInvalid}>
          <NumberStyler
            fontSize="md"
            num={balanceDetail.balance}
            assetInfo={balanceDetail.asset}
          />
        </SkeletonRect>
      </TableCell>
    </TableRow>
  );
}

export function BalanceTableHeaders({
  showChange,
}: {
  showChange?: boolean;
}): React.ReactElement {
  return (
    <TableHeaderRow>
      <TableHeaderCell>
        <Text>Asset</Text>
      </TableHeaderCell>

      {showChange && (
        <TableHeaderCell>
          <Text>Change</Text>
        </TableHeaderCell>
      )}

      <TableHeaderCell justifyContent="left">
        <Text>Data Source Balance</Text>
      </TableHeaderCell>

      <TableHeaderCell justifyContent="left">
        <Text>Portfolio Balance</Text>
      </TableHeaderCell>
    </TableHeaderRow>
  );
}
